import { FC } from 'react';

import { HeroSection } from 'components/HeroSection';
// import { DemoWrapper } from 'components/DemoWrapper';
import { Button } from 'components/Buttons';

import {
  BlueButtonWrapper,
  ButtonsWrapper,
  HeroDescription,
  HeroTitle,
  WebLeft,
  WebRight,
  Wrapper,
} from './Hero.styles';

import WebLeftImage from 'assets/applications/web-left.webp';
import WebRightImage from 'assets/applications/web-right.webp';

// import { usePlayVideoOnShow } from 'hooks/usePlayVideoOnShow';
// import { preventDefaultHandler } from 'helpers/preventDefaultHandler';

import { IApplicationHeroData } from 'types/applications';
import { BOOK_A_DEMO_LINK } from 'constants/common';

const Hero: FC<IApplicationHeroData> = ({ description, title }) => {
  // const videoRef = usePlayVideoOnShow();

  // const onClick = () => {
  //   const video = videoRef.current;

  //   if (video) {
  //     if (video.paused) {
  //       video.play();
  //     } else {
  //       video.pause();
  //     }
  //   }
  // };

  return (
    <HeroSection>
      <Wrapper>
        <WebLeft src={WebLeftImage} alt="web" />
        <WebRight src={WebRightImage} alt="web" />
        <HeroTitle>{title}</HeroTitle>

        <HeroDescription>{description}</HeroDescription>

        <ButtonsWrapper>
          <BlueButtonWrapper>
            <a
              href={BOOK_A_DEMO_LINK}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Button width={176}>Book a Demo</Button>
            </a>
          </BlueButtonWrapper>
        </ButtonsWrapper>

        {/* <Box
          display="flex"
          maxWidth="1200px"
          marginTop={{
            sm: '80px',
            xxs: '48px',
          }}
        >
          <DemoWrapper textAlign="center">
            <video
              onContextMenu={preventDefaultHandler}
              preload="yes"
              ref={videoRef}
              onClick={onClick}
              title="AILiveSim Variability Demo"
              src={videoSrc}
              muted
              loop
            />
          </DemoWrapper>

          <img src={imageSrc} alt={title} style={{ maxWidth: '100%', height: 'auto' }} />
        </Box> */}
      </Wrapper>
    </HeroSection>
  );
};

export default Hero;
